module.exports = __webpack_public_path__ + "img/header-diamondJewelry070Carat@2x.5b8cf84.webp";